import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Card, CardContent } from "src/common/components/Card";
import {
	DataTable,
	DataTableSearch,
	DataTableTitle,
	DataTableToolbar,
	DataTableWrapper,
	EmptyDataTableMessage,
	RowData
} from "src/common/components/DataTable";
import { ListPage } from "src/common/components/Page";
import { FullPagePreloader } from "src/common/components/Preloader";
import { genericMessages } from "src/messages/generic";
import { messages } from "src/views/user-list/messages";
import { useUserList } from "src/views/user-list/useUserList";
import { useUserListColumns } from "src/views/user-list/useUserListColumns";

export const UserList: React.FunctionComponent = () => {
	const { formatMessage } = useIntl();
	const { isLoading, users, activateUser, deactivateUser } = useUserList();
	const [query, setQuery] = React.useState("");
	const columns = useUserListColumns({ activateUser, deactivateUser });
	if (isLoading) {
		return <FullPagePreloader />;
	}
	return (
		<ListPage>
			<Card>
				<CardContent>
					<DataTableToolbar>
						<DataTableTitle>
							<FormattedMessage {...messages.userList} />
						</DataTableTitle>
						<DataTableSearch
							placeholder={formatMessage(
								genericMessages.searchOnPage
							)}
							query={query}
							setQuery={setQuery}
						/>
					</DataTableToolbar>
					<DataTableWrapper>
						<DataTable
							columns={columns}
							data={users as unknown as RowData[]}
							initialSortKey="name"
							query={query}
							noDataMessage={
								<EmptyDataTableMessage>
									<FormattedMessage
										{...genericMessages.noMatches}
									/>
								</EmptyDataTableMessage>
							}
						/>
					</DataTableWrapper>
				</CardContent>
			</Card>
		</ListPage>
	);
};
